export default "__VITE_ASSET__8cc9aecf__"